import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51632266"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "frisbuy-review-author__main" }
const _hoisted_2 = { class: "frisbuy-review-author__meta" }
const _hoisted_3 = { class: "frisbuy-review-author__name" }
const _hoisted_4 = { class: "frisbuy-review-author__date" }
const _hoisted_5 = {
  key: 0,
  class: "frisbuy-review-author__rating-simple"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.5475 9.00373L14.3506 8.38782L12.4744 4.54711C12.4232 4.44196 12.3389 4.35683 12.2348 4.30509C11.9736 4.17489 11.6562 4.28339 11.5256 4.54711L9.64949 8.38782L5.45256 9.00373C5.33685 9.02043 5.23106 9.07551 5.15007 9.15897C5.05215 9.26059 4.99819 9.39732 5.00005 9.5391C5.00191 9.68088 5.05943 9.81611 5.15998 9.91509L8.19652 12.9045L7.47912 17.1258C7.4623 17.224 7.47306 17.325 7.51018 17.4173C7.54731 17.5097 7.60931 17.5896 7.68916 17.6482C7.76901 17.7068 7.86352 17.7416 7.96196 17.7486C8.0604 17.7557 8.15883 17.7348 8.24611 17.6883L12 15.6953L15.754 17.6883C15.8564 17.7434 15.9755 17.7617 16.0895 17.7417C16.3771 17.6916 16.5705 17.4162 16.5209 17.1258L15.8036 12.9045L18.8401 9.91509C18.9227 9.8333 18.9773 9.72647 18.9938 9.60963C19.0384 9.31753 18.8368 9.04713 18.5475 9.00373Z",
    fill: "#212121"
  })
], -1))
const _hoisted_7 = { class: "frisbuy-review-author__rating-value" }
const _hoisted_8 = { class: "frisbuy-review-author__customer-info" }
const _hoisted_9 = { class: "frisbuy-review-author__name frisbuy-review-author__name--default" }
const _hoisted_10 = { class: "frisbuy-review-author__source" }
const _hoisted_11 = { class: "frisbuy-review-author__date" }
const _hoisted_12 = ["datetime"]

import { computed } from "vue";
import Vue3StarRating from "vue3-star-ratings";
import StarSoftRounded from "../Icons/ReviewAuthorStarSoftRounded.vue";
import StarRounded from "../Icons/ReviewAuthorStarRounded.vue";
import StarRounded16 from "../Icons/ReviewAuthorStarRounded16.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewAuthor',
  props: {
    customerName: {},
    reviewDate: {},
    rating: {},
    isSoftStarIcon: { type: Boolean },
    avatarColorIndex: {},
    view: { default: "default" }
  },
  setup(__props: any) {

const props = __props;

const customerInitial = computed(() => {
  const name = props.customerName?.trim() || "";
  return (name[0] || "A").toUpperCase();
});

const customerNamePopup = computed(() => {
  const name = props.customerName?.trim() || "";
  if (name.length <= 16) return name;
  return `${name.slice(0, 16)}...`;
});

const customerNameDefault = computed(() => {
  const name = props.customerName?.trim() || "";
  if (name.length <= 27) return name;
  return `${name.slice(0, 27)}...`;
});

const avatarColors = [
  "rgba(188, 200, 210, 1)",
  "rgba(114, 207, 154, 1)",
  "rgba(158, 204, 246, 1)",
  "rgba(127, 131, 234, 1)",
  "rgba(121, 85, 72, 1)",
];

const avatarStyle = computed(() => {
  const index = props.avatarColorIndex ?? 1;
  const normalizedColorIndex = (Math.max(1, index) - 1) % avatarColors.length;

  return {
    background: avatarColors[normalizedColorIndex],
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frisbuy-review-author", { 'frisbuy-review-author--popup': props.view === 'popup' }])
  }, [
    (props.view === 'popup')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "frisbuy-review-author__avatar",
              style: _normalizeStyle(avatarStyle.value)
            }, _toDisplayString(customerInitial.value), 5),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(customerNamePopup.value), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(props.reviewDate), 1)
            ])
          ]),
          (props.rating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(props.rating), 1)
              ]))
            : _createCommentVNode("", true),
          (props.rating)
            ? (_openBlock(), _createBlock(_unref(Vue3StarRating), {
                key: 1,
                class: "frisbuy-review-author__rating-mobile-stars",
                modelValue: props.rating,
                numberOfStars: 5,
                starSize: 16,
                starColor: "#FFFFFF",
                inactiveColor: "rgba(255, 255, 255, 0.4)",
                disableClick: true,
                customSvg: props.isSoftStarIcon ? StarSoftRounded : StarRounded16
              }, null, 8, ["modelValue", "customSvg"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(customerNameDefault.value), 1),
            (props.rating)
              ? (_openBlock(), _createBlock(_unref(Vue3StarRating), {
                  key: 0,
                  modelValue: props.rating,
                  numberOfStars: 5,
                  starSize: 12,
                  starColor: "var(--frisbuy-color-primary)",
                  inactiveColor: "var(--frisbuy-color-primary-2)",
                  disableClick: true,
                  customSvg: props.isSoftStarIcon ? StarSoftRounded : StarRounded
                }, null, 8, ["modelValue", "customSvg"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("time", {
                datetime: props.reviewDate
              }, _toDisplayString(props.reviewDate), 9, _hoisted_12)
            ])
          ])
        ], 64))
  ], 2))
}
}

})